module.exports = "/_next/static/images/ar-c25de78062277fe6dc397efb8c212099.png";